import React from 'react';
import { ExclamationTriangleIcon, MoonIcon } from '@heroicons/react/20/solid';
import { BLOCK_TYPES, hospitalLabel, timeLabel, tint } from './scheduleUtils';

// One session as a compact card — used in roster cells and the timeline's
// all-day row. Left edge carries the doctor's colour.
const BlockChip = ({ block, hospital, colour, conflict, draggable, doctorLabel, onClick, onDragStart, onDragEnd }) => {
  const leave = block.btype === 'leave';
  const place = hospitalLabel(hospital);
  const title = leave
    ? `Leave${block.bnotes ? ` · ${block.bnotes}` : ''}`
    : block.btype === 'theatre'
      ? place || 'Theatre list'
      : `${BLOCK_TYPES[block.btype].short}${place ? ` · ${place}` : ''}`;
  const detail = block.btype === 'theatre' ? [block.btheatre, block.bsurgeon].filter(Boolean).join(' · ') : '';

  const style = leave
    ? { borderLeftColor: colour, backgroundImage: 'repeating-linear-gradient(135deg, #f1f5f9 0 6px, #e8edf3 6px 12px)' }
    : { borderLeftColor: colour, background: tint(colour, block.btype === 'on_call' ? 0.07 : 0.13) };

  return (
    <button
      type="button"
      draggable={draggable}
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      title={[doctorLabel, timeLabel(block), title, detail, !leave && block.bnotes, conflict && `⚠ ${conflict}`].filter(Boolean).join('\n')}
      className={`w-full rounded-md border-l-[3px] px-2 py-1 text-left transition hover:-translate-y-px hover:shadow-md ${
        draggable ? 'cursor-grab active:cursor-grabbing' : 'cursor-pointer'
      } ${conflict ? 'ring-1 ring-red-400' : ''}`}
      style={style}
    >
      <div className="flex items-center gap-1 text-[10.5px] font-semibold leading-4 text-slate-500">
        {block.btype === 'on_call' && <MoonIcon className="h-3 w-3 shrink-0" style={{ color: colour }} />}
        {doctorLabel && <span className="font-bold" style={{ color: colour }}>{doctorLabel}</span>}
        <span className="truncate">{timeLabel(block)}</span>
        {conflict && <ExclamationTriangleIcon className="ml-auto h-3.5 w-3.5 shrink-0 text-red-500" />}
      </div>
      <div className={`truncate text-xs font-semibold leading-4 ${leave ? 'text-slate-500' : 'text-slate-800'}`}>{title}</div>
      {detail && <div className="truncate text-[10.5px] leading-4 text-slate-500">{detail}</div>}
    </button>
  );
};

export default BlockChip;
